import DOMPurify from 'dompurify';
import type { Config } from 'dompurify';

const SANITIZE_CONFIG: Config = {
  FORBID_TAGS: ['iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['srcset'],
  ALLOWED_URI_REGEXP: /^(?:https?|mailto|tel|ftp):/i
};

const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, SANITIZE_CONFIG);
};

export default sanitizeHtml;
